import React from 'react';
import { Text, View, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import { translate } from 'react-i18next';
import {
  Icon,
  Heading,
  HeadingTypes,
} from '../../components';
import Theme from '../../theme';
import { scaleText, defaultScale } from '../../utils/scaling';
const width = Dimensions.get('window').width;
const isMobile = width <= 550;
const styles = StyleSheet.create({
  formHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
    borderTopColor: 'transparent',
    paddingHorizontal: defaultScale(10),
  },
  formHeaderBorderTop: {
    borderTopWidth: defaultScale(0.5),
    borderTopColor: Theme.GREY_MEDIUM_LIGHT,
  },
  icon: {
    width: '5%',
    alignItems: 'center',
    paddingTop: defaultScale(3),
    },
  text: {
    ...Theme.textStyle.small,
    width: '20%',
    fontSize: scaleText(12),
    color: Theme.DARK_CHARCOAL,
  },
  accordionTitle: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.DARK_CHARCOAL,
    paddingVertical: defaultScale(20),
    width: '75%',
  },
});

const AccordionHeaderShoppingList = ({
  index,
  section,
  isActive,
  setActiveIndex,
  numberOfItemsSelected,
  t = this.props.translate,
  onPress = () => {},
}) => (
  <TouchableOpacity
    onPress={() => {
      if (isActive) {
        setActiveIndex(false);
      } else {
        setActiveIndex(index);
      }
      onPress();
    }}
    style={[
      styles.formHeader,
      styles.formHeaderBorderTop]}> 
    <Heading
      title={t(section.title)}
      style={styles.accordionTitle}
      headingType={HeadingTypes.HEADING_TWO}
    />
    <Text style={styles.text}>
      {numberOfItemsSelected} items left
    </Text>
    <Icon
      size={defaultScale(16)}
      color={Theme.DARK_CHARCOAL}
      style={styles.icon}
      name={isActive ? 'ios-arrow-up' : 'ios-arrow-down'}
    />
  </TouchableOpacity>
);

export default translate(['nutrition'], { wait: true })(AccordionHeaderShoppingList);
